const hasPerformanceApi = typeof window !== 'undefined' && typeof window.performance !== 'undefined';

const hasMarkApi = hasPerformanceApi && typeof window.performance.mark === 'function';
const hasMeasureApi = hasPerformanceApi && typeof window.performance.measure === 'function';
const hasClearMarksApi = hasPerformanceApi && typeof window.performance.clearMarks === 'function';
const hasClearMeasuresApi = hasPerformanceApi && typeof window.performance.clearMeasures === 'function';

export const startUserTiming = (markName) => {
    if (!hasMarkApi || !markName) return;
    window.performance.mark(markName);
};

export const endUserTiming = ({ measureName, startMark, endMark }) => {
    if (!hasMeasureApi || !measureName || !startMark || !endMark) return;

    window.performance.measure(measureName, startMark, endMark);

    if (hasClearMarksApi) {
        window.performance.clearMarks(startMark);
        window.performance.clearMarks(endMark);
    }

    if (hasClearMeasuresApi) {
        window.performance.clearMeasures(measureName);
    }
};
